import { useEffect, useState } from 'react';
import { passwordService } from 'Services/password';
import { validator } from 'Helper/validate';

export const usePasswordPolicy = (tenantId) => {
  const [passwordPolicy, setPasswordPolicy] = useState(validator.defaultPasswordPolicy);
  const [isLoadingPasswordPolicy, setLoadingPasswordPolicy] = useState(false);

  useEffect(() => {
    if (!tenantId) return;
    setLoadingPasswordPolicy(true);
    passwordService
      .getPasswordPolicy({ tenantId })
      .then((response) => setPasswordPolicy(response))
      .catch(() => {})
      .finally(() => setLoadingPasswordPolicy(false));
  }, [tenantId]);

  return {
    passwordPolicy,
    isLoadingPasswordPolicy,
  };
};
